import type { ContentType } from '@atlassian/ai-issue-create';

import type { IssueCreateSidePanelActions, PageMode } from '@confluence/issue-create-side-panel';
import type { RightSidebarContextType } from '@confluence/page-layout-context';

import { createSingleJiraIssueHandle } from './jiraWorkCreateHandlers';

type CreateJiraIssueActionsProps = {
	activeSelection?: Selection | null;
	completeKey?: string;
	container: any;
	contentId?: string;
	contentType?: ContentType;
	lastModified?: string | null;
	rightSidebarContext: RightSidebarContextType;
	actions: IssueCreateSidePanelActions;
	pageMode?: PageMode;
};

export const jiraWorkItemCreateActions = ({
	activeSelection,
	// completeKey, prop that will be used later in later issue creation modes added
	container,
	contentId,
	contentType,
	lastModified,
	rightSidebarContext,
	actions,
	pageMode,
}: CreateJiraIssueActionsProps) => {
	// switch here eventually for different jira work item create modes
	if (contentId) {
		createSingleJiraIssueHandle({
			actions,
			rightSidebarContext,
			activeSelection,
			container,
			contentId,
			contentType,
			lastModified,
			pageMode,
		});
	}
};
